// Traduções para a página inicial - Português (Brasil)
export const homePt = {
  // Seção de boas-vindas/hero
  welcome: {
    title: 'Encontre seu próximo veículo em',
    description:
      'Descreva o veículo dos seus sonhos e deixe nossa IA encontrar as melhores opções para você.',
    searchButton: 'Buscar veículos',
    aiSearchPlaceholder: 'Busque por marca, modelo, tipo, cor, condição...',
    clearSearch: 'Limpar',
    search: 'Buscar',
    voiceSearch: 'Busca por voz',
  },

  // Seção "Por que nos escolher"
  whyUs: {
    title: 'Por que nos escolher?',
    subtitle: 'Descubra por que nossos clientes confiam em nós',
    defaultFeatures: {
      quality: {
        title: 'Veículos de Qualidade',
        description:
          'Todos os nossos veículos passam por uma rigorosa inspeção de qualidade.',
      },
      experience: {
        title: 'Anos de Experiência',
        description:
          'Temos mais de 10 anos de experiência no mercado automotivo.',
      },
      service: {
        title: 'Atendimento Personalizado',
        description:
          'Acompanhamos você em todo o processo de compra do seu veículo.',
      },
    },
  },

  // Seção de contato CTA
  contactCTA: {
    title: 'Pronto para encontrar seu próximo veículo?',
    subtitle: 'Fale com a gente hoje mesmo.',
    button: 'Fale conosco',
    phone: 'Ligar agora',
    whatsapp: 'WhatsApp',
  },

  // Seção "Como chegar"
  howToArrive: {
    title: 'Como chegar?',
    subtitle: 'Encontre-nos no seguinte endereço:',
    button: 'Como chegar pelo Google Maps',
    address: 'Endereço',
    hours: 'Horário de atendimento',
    phone: 'Telefone',
    email: 'E-mail',
    ofTotal: 'de',
    showMap: 'Ver mapa',
    mapUnavailable: 'Não foi possível carregar o mapa.',
  },

  // Seção de veículos em destaque
  featuredVehicles: {
    title: 'Veículos em Destaque',
    subtitle: 'Descubra nossa seleção de veículos premium',
    viewAll: 'Ver todos os veículos',
    noVehicles: 'Não há veículos em destaque disponíveis',
  },
};
